module.exports = __webpack_public_path__ + "img/ruby2.49110432.png";